import * as React from 'react';

export function Button({ children, disabled, onClick }: { children: React.ReactNode; disabled?: boolean, onClick?: React.MouseEventHandler<HTMLButtonElement>; }) {
    return <button className="flex items-center justify-center py-3 px-4 h-11 w-full bg-gray-900 text-white rounded-lg font-medium leading-5 text-center" onClick={onClick} disabled={disabled}>
        {children}
    </button>;
}
